module.exports = __webpack_public_path__ + "static/media/x.5f6f2461.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icon/x.svg
// module id = 481
// module chunks = 0